/**
 * Indicates the type of error in the `error` field of the DatalayerUserConsent object when the consent string is empty.
 */
export enum ConsentError {
  CmpFail = "cmp_fail",
  OutsideCanada = "outside_canada",
}
